export const documentTypeMapToFields = {
  1: { fields: [], documents: ['customerID'] },
  3: {
    fields: ['streetAddress', 'numberAddress', 'postalCode', 'city', 'country'],
    documents: ['proofOfAddress'],
  },
  5: {
    fields: ['streetAddress', 'numberAddress', 'postalCode', 'city', 'country'],
    documents: [],
  },
  6: { fields: [], documents: ['knowYourCustomer'] },
  7: {
    fields: ['companyName', 'vatNumber', 'companyRegistrationNumber'],
    documents: ['companyRegistration'],
  },
  13: {
    fields: ['streetAddress', 'numberAddress', 'postalCode', 'city', 'country'],
    documents: ['proofOfAddress'],
  },
  17: { fields: [], documents: ['lastInvoiceDocument'] },
};

export const documentTypeMapToColumns = {
  1: 'customerID',
  3: 'proofOfAddress',
  5: 'streetAddress',
  6: 'knowYourCustomer',
  7: 'companyRegistration',
  13: 'proofOfAddress',
  14: 'companyRegistrationNumber',
  17: 'lastInvoiceDocument',
};
